const initialData = {
    tenders: [
        {
            id: 1,
            tenderNo: 'TND-2026-001',
            title: 'Medical Equipment Supply for Cardiology Dept',
            organization: 'City Hospital',
            currentStage: 3,
            stageName: 'Submitted Tender',
            submissionDate: '2026-03-01',
            value: 15400000,
            earnestMoneyAmount: 750000,
            earnestMoneyReleased: false,
            performanceSecurityAmount: 0,
            documents: [
                { id: 101, name: 'Tender_Notice.pdf', size: 102400, docType: 'Tender Notice', path: '#' }
            ],
            Quotations: []
        },
        {
            id: 2,
            tenderNo: 'TND-2026-002',
            title: 'Enterprise ERP Software Implementation',
            organization: 'Tech Corp',
            currentStage: 9,
            stageName: 'Awarded Tender (Pending Delivery)',
            submissionDate: '2026-02-15',
            value: 28500000,
            earnestMoneyAmount: 1400000,
            earnestMoneyReleased: true,
            performanceSecurityAmount: 2850000,
            documents: [
                { id: 102, name: 'Award_Letter.pdf', size: 204800, docType: 'Technical Bid Final Uploaded', path: '#' }
            ],
            Quotations: [
                { id: 1, quoteNo: 'QUO-2026-001', title: 'ERP Software Quote', status: 'Awarded', grandTotal: 28500000 }
            ]
        },
        {
            id: 3,
            tenderNo: 'TND-2026-003',
            title: 'Furniture Supply for New Office Wing',
            organization: 'Gov Office',
            currentStage: 14,
            stageName: 'Closed Tender',
            submissionDate: '2026-01-20',
            value: 4200000,
            earnestMoneyAmount: 210000,
            earnestMoneyReleased: true,
            performanceSecurityAmount: 420000,
            documents: [
                { id: 103, name: 'Contract_Copy.pdf', size: 512000, docType: 'Contract Copy', path: '#' }
            ],
            Quotations: []
        },
    ],
    quotations: [
        {
            id: 1,
            quoteNo: 'QUO-2026-001',
            tenderId: 2,
            Tender: { id: 2, tenderNo: 'TND-2026-002', title: 'Enterprise ERP Software Implementation' },
            organization: 'Tech Corp',
            subject: 'ERP Software Quote',
            submissionDate: '2026-02-10',
            grandTotal: 28500000,
            status: 'Awarded',
            currentStage: 3,
            stageName: 'Awarded',
            designation: 'CTO',
            toContact: 'Alice Smith',
            validityDate: '2026-05-10',
            QuotationItems: [
                { id: 1, description: 'ERP Core License', quantity: 1, unitPrice: 20000000, totalPrice: 20000000 },
                { id: 2, description: 'Implementation Support', quantity: 1, unitPrice: 8500000, totalPrice: 8500000 }
            ]
        },
        {
            id: 2,
            quoteNo: 'QUO-2026-002',
            tenderId: 1,
            Tender: { id: 1, tenderNo: 'TND-2026-001', title: 'Medical Equipment Supply for Cardiology Dept' },
            organization: 'City Hospital',
            subject: 'Medical Devices Quote',
            submissionDate: '2026-03-02',
            grandTotal: 15400000,
            status: 'Sent',
            currentStage: 2,
            stageName: 'Submitted',
            designation: 'Head of IT',
            toContact: 'Bob Johnson',
            validityDate: '2026-06-02',
            QuotationItems: [
                { id: 3, description: 'Advanced Diagnostic Monitor', quantity: 5, unitPrice: 3000000, totalPrice: 15000000 },
                { id: 4, description: 'Installation', quantity: 1, unitPrice: 400000, totalPrice: 400000 }
            ]
        },
    ],
    products: [
        {
            id: 1,
            modelNumber: 'PRD-LPT-001',
            name: 'Pro Laptop 15"',
            brand: 'Premium Tech',
            BrandId: 1,
            price: 150000,
            description: 'High performance laptop for professionals',
            ProductStocks: [
                { id: 1, WarehouseId: 1, quantity: 45, Warehouse: { name: 'Main Warehouse' } }
            ]
        },
        {
            id: 2,
            modelNumber: 'PRD-CHR-002',
            name: 'Ergonomic Office Chair',
            brand: 'Comfort Plus',
            BrandId: 2,
            price: 25000,
            description: 'Adjustable mesh chair for long hours',
            ProductStocks: [
                { id: 2, WarehouseId: 1, quantity: 120, Warehouse: { name: 'Main Warehouse' } }
            ]
        },
        {
            id: 3,
            modelNumber: 'PRD-MON-003',
            name: '4K Medical Monitor',
            brand: 'MedView',
            BrandId: 3,
            price: 450000,
            description: 'High resolution monitor for surgical use',
            ProductStocks: [
                { id: 3, WarehouseId: 1, quantity: 12, Warehouse: { name: 'Main Warehouse' } }
            ]
        },
    ],
    shipments: [
        {
            id: 1,
            shipmentNo: 'SHP-2026-001',
            supplier: 'Global IT Supplies',
            date: '2026-02-25',
            location: 'Main Warehouse',
            Product: { modelNumber: 'PRD-LPT-001', name: 'Pro Laptop 15"' },
            quantity: 20
        },
        {
            id: 2,
            shipmentNo: 'SHP-2026-002',
            supplier: 'Furniture World',
            date: '2026-02-28',
            location: 'Main Warehouse',
            Product: { modelNumber: 'PRD-CHR-002', name: 'Ergonomic Office Chair' },
            quantity: 50
        }
    ],
    transfers: [],
    stockout: [
        {
            id: 1,
            Project: { title: 'Smart Hospital Initiative' },
            Product: { modelNumber: 'PRD-MON-003', name: '4K Medical Monitor' },
            quantity: 2,
            fromWarehouse: 'Main Warehouse',
            date: '2026-03-02'
        }
    ],
    organizations: [
        {
            id: 1,
            name: 'City Hospital',
            ntn: '1234567-8',
            abbreviation: 'CH',
            city: 'Karachi',
            country: 'Pakistan',
            contactPerson: 'Jane Smith',
            designation: 'Head of IT',
            location: '123 Health Ave, Karachi',
            email: 'info@cityhospital.pk',
            phone: '021-34567890'
        },
        {
            id: 2,
            name: 'Tech Corp',
            ntn: '8765432-1',
            abbreviation: 'TC',
            city: 'Lahore',
            country: 'Pakistan',
            contactPerson: 'John Wick',
            designation: 'CTO',
            location: '45 IT Plaza, Lahore',
            email: 'contact@techcorp.pk',
            phone: '042-99887766'
        },
        {
            id: 3,
            name: 'Gov Office',
            ntn: '4455667-2',
            abbreviation: 'GO',
            city: 'Islamabad',
            country: 'Pakistan',
            contactPerson: 'Alice Wonderland',
            designation: 'Director Procurement',
            location: 'Secretariat Road, Islamabad',
            email: 'procurement@gov.pk',
            phone: '051-22334455'
        }
    ],
    projects: [
        {
            id: 1,
            title: 'Smart Hospital Initiative',
            Organization: { name: 'City Hospital' },
            OrganizationId: 1,
            status: 'active',
            startDate: '2026-03-01',
            endDate: '2026-12-31',
            description: 'Implementing digital health records and monitoring system',
            ProjectDocuments: [
                { id: 201, name: 'LOI_Project.pdf', type: 'Letter Of Intent', path: '#' }
            ]
        },
        {
            id: 2,
            title: 'ERP Deployment - Phase 1',
            Organization: { name: 'Tech Corp' },
            OrganizationId: 2,
            status: 'planning',
            startDate: '2026-04-15',
            endDate: '2026-09-15',
            description: 'Core module deployment including Finance and HR',
            ProjectDocuments: []
        }
    ],
    contacts: [
        {
            id: 1,
            name: 'Jane Smith',
            organization: 'City Hospital',
            OrganizationId: 1,
            Organization: { name: 'City Hospital' },
            designation: 'Head of IT',
            email: 'jane.smith@cityhospital.pk',
            phone: '0300-1122334'
        },
        {
            id: 2,
            name: 'John Wick',
            organization: 'Tech Corp',
            OrganizationId: 2,
            Organization: { name: 'Tech Corp' },
            designation: 'CTO',
            email: 'j.wick@techcorp.pk',
            phone: '0300-9988776'
        }
    ],
    users: [
        { id: 1, name: 'Bilal Ahmed', email: 'admin@rsms.com', role: 'Administrator' },
        { id: 2, name: 'Sadaf Khan', email: 'manager@rsms.com', role: 'Manager' },
    ],
    company: {
        name: 'Cube Techwiz',
        email: 'info@cubetechwiz.com',
        phone: '+92 336 3219492',
        address: 'Pakistan',
        logo: '/logo.png',
        website: 'www.cubetechwiz.com',
        ntn: '',
        stRegistration: 'STR-44556677'
    },
    records: [
        {
            id: 1,
            recordNo: 'REC-2026-001',
            date: '2025-12-30',
            organization: 'City Hospital',
            project: 'Smart Hospital Initiative',
            quotation: '',
            author: 'Bilal Ahmed',
            type: 'Audit Report',
            attachment: ['Audit_2025.pdf'],
            description: 'Year-end inventory verification completed successfully'
        },
        {
            id: 2,
            recordNo: 'REC-2026-002',
            date: '2026-03-01',
            organization: 'Gov Office',
            project: '',
            quotation: 'QUO-2026-002',
            author: 'Sadaf Khan',
            type: 'Notification',
            attachment: ['Tender_List_Mar.pdf'],
            description: 'List of all new tenders published in March'
        }
    ],
    logs: [
        { id: 1, action: 'Exported P&L Report', user: 'Bilal Ahmed', timestamp: '2026-03-03 09:15:22' },
        { id: 2, action: 'Created New Tender TND-2026-001', user: 'Bilal Ahmed', timestamp: '2026-03-03 10:10:05' }
    ],
    notifications: [
        { id: 1, message: 'Tender TND-2026-001 submission deadline approaching!', read: false, date: '2026-03-03' },
        { id: 2, message: 'New Stock Shipment SHP-2026-002 received.', read: true, date: '2026-02-28' }
    ],
    warehouses: [
        { id: 1, name: 'Main Warehouse', location: 'SITE Area, Karachi', description: 'Primary storage for all electronics' },
        { id: 2, name: 'Lahore Hub', location: 'Ferozepur Road, Lahore', description: 'Regional distribution center' }
    ],
    brands: [
        { id: 1, name: 'Premium Tech', description: 'High-end computing hardware' },
        { id: 2, name: 'Comfort Plus', description: 'Office furniture solutions' },
        { id: 3, name: 'MedView', description: 'Specialized medical imaging' }
    ],
    deliveryChallans: [
        {
            id: 1,
            dcNumber: 'DC-2026-401',
            deliveryDate: '2026-03-02',
            Quotation: { id: 2, quoteNo: 'QUO-2026-002' },
            Project: { id: 1, title: 'Smart Hospital Initiative' },
            receiverName: 'Mr. Asif',
            status: 'Delivered',
            organization: 'City Hospital',
            location: 'Dept of Cardiology, City Hospital',
            items: [
                { id: 1, description: '4K Medical Monitor', quantity: 2 }
            ],
            DeliveryChallanItems: [
                { id: 1, QuotationItemId: 3, description: '4K Medical Monitor', quantity: 2, Product: { modelNumber: 'PRD-MON-003' } }
            ]
        },
    ],
    invoices: [
        {
            id: 1,
            invoiceNumber: 'INV-2026-901',
            Organization: { name: 'City Hospital', ntn: '1234567-8', address: '123 Health Ave, Karachi' },
            date: '2026-03-03',
            dueDate: '2026-04-03',
            status: 'Sent',
            subTotal: 900000,
            discount: 0,
            grandTotal: 1062000,
            DeliveryChallans: [
                { dcNumber: 'DC-2026-401' }
            ],
            InvoiceItems: [
                { id: 1, description: '4K Medical Monitor', quantity: 2, unitPrice: 450000, totalPrice: 900000 }
            ],
            SalesTaxInvoice: {
                id: 1,
                stInvoiceNumber: 'STI-2026-501',
                invoiceDate: '2026-03-03',
                taxRate: 18,
                buyerNTN: '1234567-8',
                sellerNTN: ''
            }
        },
    ]
};

// Helper for persistence
const STORAGE_KEY = 'rsms_mock_db';

const getStore = () => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : initialData;
};

const saveStore = (data) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
};

export const mockDb = {
    get: (collection) => {
        const store = getStore();
        return Promise.resolve({ data: store[collection] });
    },
    getById: (collection, id) => {
        const store = getStore();
        const item = store[collection].find(i => i.id === parseInt(id));
        return Promise.resolve({ data: item });
    },
    create: (collection, data) => {
        const store = getStore();
        const newItem = { ...data, id: Date.now() };
        store[collection].unshift(newItem);
        saveStore(store);
        return Promise.resolve({ data: newItem });
    },
    update: (collection, id, data) => {
        const store = getStore();
        const index = store[collection].findIndex(i => i.id === parseInt(id));
        if (index !== -1) {
            store[collection][index] = { ...store[collection][index], ...data };
            saveStore(store);
            return Promise.resolve({ data: store[collection][index] });
        }
        return Promise.reject({ response: { status: 404 } });
    },
    delete: (collection, id) => {
        const store = getStore();
        store[collection] = store[collection].filter(i => i.id !== parseInt(id));
        saveStore(store);
        return Promise.resolve({ data: { success: true } });
    }
};
